import { render, staticRenderFns } from "./ModeSwitcher.vue?vue&type=template&id=a18bb934&scoped=true&"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js&"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ModeSwitcher.vue?vue&type=style&index=0&id=a18bb934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18bb934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs,VTabsSlider})
